import ListPageLayout from "../../componets/layout/ListPageLayout";
import propertyApi from "../../services/propertyApi";

export default function Properties() {
    return(

        <ListPageLayout
            title={'Lista Imóveis'}
            urlCreate={'/imoveis/formulario'}
            queries={{['relations']: 'city,state,tipo' }}
            properties
            table={
                {
                    loader: propertyApi.all,
                    columns: [
                        { label: "CEP", index: "cep", type: 'cep'},
                        { label: "Setor", index: "bairro", type: 'string'},
                        { label: "Endereço", index: "address", type: 'address'},
                        { label: "Cidade", index: "city.description", type: 'string'},
                        { label: "Estado", index: "state.description", type: 'string'},
                        { label: "Tipo", index: "tipo.descricao", type: 'string'},
                    ]
                }
            }
        />
    )
}